/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Birth_ErrorInputs */

const en_us2_profile_editors_birth_error = /** @type {(inputs: Profile_Editors_Birth_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a valid date.`)
};

const pt_br2_profile_editors_birth_error = /** @type {(inputs: Profile_Editors_Birth_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha uma data válida.`)
};

const es_419_profile_editors_birth_error = /** @type {(inputs: Profile_Editors_Birth_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige una fecha válida.`)
};

const pt_pt2_profile_editors_birth_error = /** @type {(inputs: Profile_Editors_Birth_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolhe uma data válida.`)
};

const fr_fr2_profile_editors_birth_error = /** @type {(inputs: Profile_Editors_Birth_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisis une date valide.`)
};

const de_de2_profile_editors_birth_error = /** @type {(inputs: Profile_Editors_Birth_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähl ein gültiges Datum.`)
};

const it_it2_profile_editors_birth_error = /** @type {(inputs: Profile_Editors_Birth_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli una data valida.`)
};

/**
* | output |
* | --- |
* | "Pick a valid date." |
*
* @param {Profile_Editors_Birth_ErrorInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_birth_error = /** @type {((inputs?: Profile_Editors_Birth_ErrorInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Birth_ErrorInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_birth_error(inputs)
	if (locale === "es-419") return es_419_profile_editors_birth_error(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_birth_error(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_birth_error(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_birth_error(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_birth_error(inputs)
	return en_us2_profile_editors_birth_error(inputs)
});
export { profile_editors_birth_error as "profile-editors.birth_error" }